import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from "vue";

type CollapsableCardProps = {
  cardTitle: string;
  cardSubtitle?: string;
  customStyle?: string | Record<string, string | number>;
  expanded?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsableCard',
  props: {
    cardTitle: { default: '' },
    cardSubtitle: { default: '' },
    customStyle: { default: '' },
    expanded: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { cardTitle: string, cardSubtitle: string, customStyle: string | Record<string, string | number>, expanded: boolean };



const isExpanded = ref(props.expanded);
const computedStyle = computed(() => {
  if (typeof props.customStyle === 'string') {
    return props.customStyle;
  }
  return { ...props.customStyle };
});

function expandAccordion() {
  isExpanded.value = !isExpanded.value;
}

return { __sfc: true,props, isExpanded, computedStyle, expandAccordion }
}

})